import {CommonOptionVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class BarcodeOptionsVM extends CommonOptionVM {
  required: boolean;

  constructor(data: Partial<BarcodeOptionsVM> = {}) {
    super(data)
    this.required = data.required || false
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default BarcodeOptionsVM